import { RegionalDistrictsPopupButtonContainer } from '../RegionalDistricts/PopupButtonContainer';
import { UndergroundPopupButtonContainer } from '../UndergroundContainer/PopupButtonContainer';
import { LocationSwitcherPopupButtonContainer } from '../LocationSwitcher/PopupButtonContainer';
import { DistrictsPopupButtonContainer } from '../DistrictsContainer/PopupButtonContainer';
import { DirectionsPopupButtonContainer } from '../DirectionsContainer/PopupButtonContainer';
import { GeoInputAddonSection } from '../../../../../packages/GeoComponents';

export function GeoSwitcherButtonsContainer() {
  return (
    <GeoInputAddonSection>
      <LocationSwitcherPopupButtonContainer />
      <RegionalDistrictsPopupButtonContainer />
      <DistrictsPopupButtonContainer />
      <DirectionsPopupButtonContainer />
      <UndergroundPopupButtonContainer />
    </GeoInputAddonSection>
  );
}
